import React, { useEffect, useState } from 'react';
import { AvField, AvForm } from "availity-reactstrap-validation";
import { useTranslation } from 'react-i18next';
import { useFormik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Card, CardBody, Col, Container, Label, Row } from "reactstrap";
import { coeffAbattKmActions } from './coeffAbattKmSlice';

const initForm = {
    categVeh: '',
    kmMoyenAnnuelDi: '',
    kmMoyenAnnuelEs: '',
    kmMoyenAnnuelHy: '',
    percentValue: '',
    percentKm: ''
}
const CoeffRelatifForm = ({ editingItem }) => {

    const { t } = useTranslation('translation');
    const { categVH } = useSelector(state => state.data);
    const [form, setForm] = useState(initForm);

    const dispatch = useDispatch();

    const formik = useFormik({
        initialValues: {...form},
        enableReinitialize: true,
        onSubmit: (values, { resetForm }) => {
            console.log('Submitting values:', values);
            let payload = {
                data: values,
                onSuccess: () => {
                    dispatch(coeffAbattKmActions.listCoeffAbattKm());
                }
            };
            if (values?.id > 0) {
                dispatch(coeffAbattKmActions.updateCoeffAbattKm(payload));
            } else {
                dispatch(coeffAbattKmActions.createCoeffAbattKm(payload));
            }
            resetForm();

        }
    });

    useEffect(() => {
        if (editingItem) {
            setForm({...editingItem});
        }
    }, [editingItem]);

    const handleChangePuissFiscaleKm = (e) => {
        const { value } = e.target;
        formik.setFieldValue('categVeh', value);
    };

    const { getFieldProps } = formik;

    return (
        <AvForm className="needs-validation" onValidSubmit={formik.handleSubmit}>
            <Row className="mb-4">
                <Col md="4">
                <Label htmlFor="puissance" className="form-label">{t('parametrage.categorie')}</Label>

                    <select
                        className="form-control"
                        id="categorie"
                        {...getFieldProps('categVeh')}
                        onChange={handleChangePuissFiscaleKm}
                    >
                        <option value="">{t('Sélectionner...')}</option>
                        {categVH?.map((option, index) => (
                            <option key={index} value={option.code}>
                                {option.description}
                            </option>
                        ))}
                    </select>
                </Col>
            </Row>
            <Row>
                <Col md="4">
                    <Label className="form-label" htmlFor="kmMoyAnnuelD">{t('parametrage.kmMoyAnnuelD')}</Label>
                    <AvField
                        {...getFieldProps('kmMoyenAnnuelDi')}
                        type="text"
                        errorMessage={t('message.required')}
                        className="form-control"
                        id="kmMoyAnnuelD"
                    />
                </Col>
                <Col md="4">
                    <Label className="form-label" htmlFor="kmMoyAnnuelE">{t('parametrage.kmMoyAnnuelE')}</Label>
                    <AvField
                        {...getFieldProps('kmMoyenAnnuelEs')}
                        type="text"
                        errorMessage={t('message.required')}
                        className="form-control"
                        id="kmMoyAnnuelE"
                    />
                </Col>
                <Col md="4">
                    <Label className="form-label" htmlFor="kmMoyAnnuelH">{t('parametrage.kmMoyAnnuelH')}</Label>
                    <AvField
                        {...getFieldProps('kmMoyenAnnuelHy')}
                        type="text"
                        errorMessage={t('message.required')}
                        className="form-control"
                        id="kmMoyAnnuelH"
                    />
                </Col>
            </Row>
            <Row>
                <Col md="6">
                    <Label className="form-label" htmlFor="coefEnPlus">{t('parametrage.coefEnPlus')}</Label>
                    <div className="d-flex align-items-center">
                        <AvField
                            {...getFieldProps('percentValue')}
                            type="text"
                            errorMessage={t('message.required')}
                            className="form-control"
                            placeholder="%"
                            id="coefEnPlus"
                        />
                        <span className="mx-2">/</span>
                        <AvField
                            {...getFieldProps('percentKm')}
                            type="text"
                            errorMessage={t('message.required')}
                            className="form-control"
                            placeholder="Km"
                            id="percentKm"
                        />

                    </div>
                </Col>
            </Row>
            <Col md="12" className="d-flex justify-content-end">
                <Button color="primary" size="sm" type="submit">{t('actions.save')}</Button>
                <Button color="danger" size="sm" type='reset' className="mx-2" onClick={() => setForm({...initForm})}>{t('actions.clear')}</Button>
            </Col>
        </AvForm>
    );
};

export default CoeffRelatifForm;
